import * as Yup from "yup";

const step1Schema = Yup.object({
    // userId: Yup.string().uuid().required("User ID is required"),
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    about: Yup.string().required("About is required"),
    domain: Yup.string().required("Domain is required"),
    otherDomainInput: Yup.string().when("domain", {
        is: "Others",
        then: (schema) => schema.required("Please specify your domain"),
        otherwise: (schema) => schema.optional()
    }),
    ventureStage: Yup.string().required('venture stage is required'),
    fundingStage: Yup.string().required('funding stage is required'),
    websiteUrl: Yup.string().optional(),
    incubatorName: Yup.string().optional(),
    otherIncubatorName: Yup.string().when("incubatorName", {
        is: "Others",
        then: (schema) => schema.required("Please specify your incubator"),
        otherwise: (schema) => schema.optional()
      }),
    coWorkingName: Yup.string().optional(),
    otherCoWorkingName: Yup.string().when("coWorkingName", {
        is: "Others",
        then: (schema) => schema.required("Please specify your co-working space"),
        otherwise: (schema) => schema.optional()
      })
});

const step2Schema = step1Schema.shape({
    coFounders: Yup.array().of(
        Yup.object().shape({
            userType: Yup.string().optional(),
            id: Yup.string().optional()
        })
    ),
    noOfCustomers: Yup.object({
        number: Yup.string().optional(),
        hidden: Yup.boolean().optional()
    }),
    teamSize: Yup.object({
        number: Yup.string().optional(),
        hidden: Yup.boolean().optional()
    }),
    linkCompanyPage: Yup.boolean().optional()
});

const step3Schema = step2Schema.shape({
    isHiring: Yup.boolean().optional(),
    isSeekingCofounderHiring: Yup.boolean().optional(),
    hiring: Yup.array().of(
        Yup.object({
            title: Yup.string().required("Job title is required"),
            domain: Yup.string().required("Domain is required"),
            description: Yup.string().optional()
        })
    ),
    logo: Yup.string().optional(),
    banner: Yup.string().optional()
});

export { step1Schema, step2Schema, step3Schema }
